import React, { useEffect, useState } from "react";
import jwtDecode from "jwt-decode";
import {Link} from 'react-router-dom';

import {
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  ListSubheader,
  List,
} from "@mui/material";
import {
  Dashboard,
  ShoppingCart,
  People,
  Logout,
  Vaccines,
  Accessibility,
  MonitorHeart
} from "@mui/icons-material";

import { useLocation } from "react-router-dom";

import { logout } from "../../api/auth.jsx";

const listItem = [
  {
    role: ["admin", "perawat", "dokter"],
    link: "/",
    label: "Dashboard",
    icon: <Dashboard />,
  },
  {
    role: ["perawat"],
    link: "request-obat",
    label: "Request Obat",
    icon: <ShoppingCart />,
  },
  {
    role: ["admin", "perawat"],
    link: "/data-obat",
    label: "Data Obat",
    icon: <People />,
  },
  {
    role: ["dokter"],
    link: "rekam-medis",
    label: "Rekam Medis",
    icon: <MonitorHeart />,
  },
  {
    role: ["dokter"],
    link: "body-composition",
    label: "Body Composition",
    icon: <Accessibility />,
  },
  {
    role: ["dokter"],
    link: "swab",
    label: "Swab",
    icon: <Vaccines />,
  },
];

export default function MainListItem() {
  let [user, setUser] = useState(null);
  const location = useLocation();
  const handleSetUser = () => {
    const token = localStorage.getItem("token");
    if (token && token !== null) {
      setUser(jwtDecode(token));
    }
  };

  useEffect(() => {
    if (user === null) {
      handleSetUser();
    }
  });

  return (
    <List>
      {user !== null &&
        listItem.map(
          (el) =>
            el.role.includes(user.user.role) && (
              <ListItem
                key={`${el.link}-${el.label}`}
                disablePadding
                selected={el.link === location.pathname}
              >
                <ListItemButton component={Link} to={el.link}>
                  <ListItemIcon>{el.icon}</ListItemIcon>

                  <ListItemText primary={el.label} />
                </ListItemButton>
              </ListItem>
            )
        )}
    </List>
  );
}

export const secondaryListItems = (
  <div>
    <ListSubheader inset>Menu User</ListSubheader>
    <ListItem button onClick={() => logout()}>
      <ListItemIcon>
        <Logout />
      </ListItemIcon>
      <ListItemText primary="Logout" />
    </ListItem>
  </div>
);
